import * as React from 'react';
import { HowAcademyWorksPayload, SectionUIProps } from '~/common/types/types';
import { FormattedMessage, SectionLayout } from '~/components/common/common';
import { HowAcademyWorksList } from './components/components';
import * as styles from './how-academy-works.module.scss';

type Props = SectionUIProps & {
  payload: HowAcademyWorksPayload;
};

const HowAcademyWorks: React.FC<Props> = ({ payload }) => {
  const { title, description, items } = payload;

  return (
    <SectionLayout
      headingMessage={title}
      classes={{
        wrapper: styles.wrapper,
      }}
    >
      <p className={styles.description}>
        <FormattedMessage message={description} />
      </p>
      <HowAcademyWorksList items={items} />
    </SectionLayout>
  );
};

export { HowAcademyWorks };
